import { apiRequest } from './httpClient';

export const getMarketingOAuthConnections = () => apiRequest('getMarketingOAuthConnections', {
  method: 'GET',
});

export const startMarketingOAuth = (provider) => apiRequest('startMarketingOAuth', {
  method: 'POST',
  body: { provider },
});

export const disconnectMarketingOAuth = (provider) => apiRequest('disconnectMarketingOAuth', {
  method: 'POST',
  body: { provider },
});
